import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AgreeJurPersonObj, AgreeNatPersonObj } from './agree';
import { ApiService } from '@core/services/api.service';
import { AuthService } from '@core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class Agree21Service {
  agreeNatPersonObj = new AgreeNatPersonObj();
  agreeJurPersonObj = new AgreeJurPersonObj();

  private readonly auth = inject(AuthService);
  private readonly api = inject(ApiService);

  private personenNummer?: string | number;
  private iban?: string;

  /**
   * Fällt auf die Werte des angemeldeten Benutzers zurück, solange der Abschluss-Flow
   * noch keine eigenen gesetzt hat - der Service wird erzeugt, bevor der Benutzer geladen ist.
   */
  get PERSONEN_NUMMER(): string | number | undefined {
    return this.personenNummer ?? this.auth.user?.kundenNummer;
  }

  set PERSONEN_NUMMER(value: string | number | undefined) {
    this.personenNummer = value;
  }

  get IBAN(): string | undefined {
    return this.iban ?? this.auth.user?.iban;
  }

  set IBAN(value: string | undefined) {
    this.iban = value;
  }

  postNatPersonKontokorrent(creditLimitAmount: number): Observable<any> {
    return this.api.post('agree21api/natPersonKontokorrent', {
      creditLimitAmount,
      steuerID: '',
      _id: this.auth.user._id,
    });
  }

  postJurPerson(creditLimitAmount: number): Observable<any> {
    return this.api.post('agree21api/createJurPerson', {
      creditLimitAmount,
      steuerID: '',
      _id: this.auth.user._id,
    });
  }

  postGbRPerson(creditLimitAmount: number): Observable<any> {
    return this.api.post('agree21api/createGbrPerson', {
      creditLimitAmount,
      _id: this.auth.user._id,
    });
  }

  postGirocardOnlineBanking(
    Personennummer: string | number | undefined,
    iban: string | undefined,
    wunschAlias: string | undefined,
    onlineBankingPublicKey: string | undefined
  ): Observable<any> {
    return this.api.post('agree21api/girocardOnlineBanking', {
      Personennummer,
      iban,
      wunschAlias,
      onlineBankingPublicKey,
      _id: this.auth.user._id,
    });
  }

  getPublicKey(): Observable<string> {
    return this.api.getText('agree21api/getPublicKey');
  }
}
